export const ZONES = [
  { name: "Punta Cana Village", slug: "punta-cana-village" },
  { name: "Downtown Punta Cana", slug: "downtown-punta-cana" },
  { name: "Vista Cana", slug: "vista-cana" },
  { name: "Cap Cana", slug: "cap-cana" },
  { name: "Punta Cana Resort", slug: "punta-cana-resort" },
  { name: "Bávaro", slug: "bavaro" },
];
export const ZONE_NAMES = ZONES.map((z) => z.name);
export const TYPES = ["Estudio", "Apartamento", "Penthouse", "Townhouse", "Villa", "Casa"];
export const FURNISHED = [
  { value: "amueblado", label: "Amueblada" },
  { value: "semi_amueblado", label: "Semi amueblada" },
  { value: "sin_muebles", label: "Sin muebles" },
];
export const PROP_STATUS = [
  { value: "borrador", label: "Borrador" },
  { value: "disponible", label: "Disponible" },
  { value: "reservada", label: "Reservada" },
  { value: "alquilada", label: "Alquilada" },
  { value: "archivada", label: "Archivada" },
];
export const LEAD_STATUS = [
  { value: "nuevo", label: "Nuevo" },
  { value: "contactado", label: "Contactado" },
  { value: "calificado", label: "Calificado" },
  { value: "visita", label: "Visita" },
  { value: "negociacion", label: "Negociación" },
  { value: "contrato", label: "Contrato" },
  { value: "cerrado", label: "Cerrado" },
  { value: "perdido", label: "Perdido" },
];
export const AD_CATEGORIES = ["Mudanzas", "Limpieza", "Muebles", "Decoración", "Aire acondicionado", "Electricidad", "Plomería",
  "Seguridad", "Internet", "Mantenimiento", "Servicios de reubicación", "Otros proveedores"];
export const PARTIDAS = ["Terreno", "Estudios", "Diseño", "Permisos", "Movimiento de tierra", "Cimentación", "Estructura",
  "Albañilería", "Instalaciones", "Terminaciones", "Equipamiento", "Paisajismo", "Imprevistos"];
export const TX_CATEGORIES = ["Comisiones", "Publicidad", "Otros ingresos", "Marketing", "Nómina", "Oficina", "Software",
  "Impuestos", "Transporte", "Construcción", "Otros gastos"];
export const ROLES = [
  { value: "superadmin", label: "Superadministrador" },
  { value: "admin_inmobiliario", label: "Administrador inmobiliario" },
  { value: "agente", label: "Agente" },
  { value: "contabilidad", label: "Contabilidad" },
  { value: "construccion", label: "Responsable de construcción" },
  { value: "editor", label: "Editor de contenido" },
];
export const label = (list, v) => (list.find((x) => x.value === v) || {}).label || v || "—";
export const opts = (arr) => arr.map((x) => (typeof x === "string" ? { value: x, label: x } : x));
